"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setPowerSaveMode = void 0;
var DeviceCharacteristic_1 = require("../../../common/DeviceCharacteristic");
var dataViewParsers_1 = require("../parsers/dataViewParsers");
var setPowerSaveMode = function (device, value, withResponse) {
    return device
        .writeCharacteristicValues(device.profile.VAPING.characteristics.find(function (c) { return c.name === DeviceCharacteristic_1.VapingCharacteristics.POWER_SAVER_MODE; }).uuid, value, withResponse)
        .then(function (res) { return (0, dataViewParsers_1.parsePowerSaveMode)(res); });
};
exports.setPowerSaveMode = setPowerSaveMode;
